/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Nav_LinearInputs */

const en_mk_cmp_nav_linear = /** @type {(inputs: Mk_Cmp_Nav_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Linear`)
};

const id_mk_cmp_nav_linear = /** @type {(inputs: Mk_Cmp_Nav_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Linear`)
};

/**
* | output |
* | --- |
* | "vs Linear" |
*
* @param {Mk_Cmp_Nav_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_nav_linear = /** @type {((inputs?: Mk_Cmp_Nav_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Nav_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_nav_linear(inputs)
	return en_mk_cmp_nav_linear(inputs)
});